import React from 'react'

// Buttons stay clickable and the guard logic lives in the passed-in
// onDecrement/onIncrement handlers themselves (same "no-op if over limit"
// behaviour as the original inline onClick conditions).
const QuantityStepper = ({ value, onDecrement, onIncrement, onInputChange, onInputBlur }) => (
  <div className="edv2-stepper">
    <button type="button" className="edv2-stepper__btn" onClick={onDecrement} aria-label="Decrease quantity">
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 6H10" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      </svg>
    </button>
    <input
      type="number"
      className="edv2-stepper__input"
      value={value ?? 0}
      onChange={onInputChange}
      onBlur={onInputBlur}
    />
    <button type="button" className="edv2-stepper__btn edv2-stepper__btn--add" onClick={onIncrement} aria-label="Increase quantity">
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 2V10M2 6H10" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      </svg>
    </button>
  </div>
)

export default QuantityStepper
